import React, { useState, useEffect, useCallback } from "react";
import "../Chat.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faXmark } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

function Chat() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: "Bot",
      text: "Hi there, feel free to ask questions about skills, experiences, education!",
    },
  ]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);

  const handleSendMessage = useCallback(
    async (event) => {
      event.preventDefault();
      if (text.trim()) {
        const userMessage = { role: "User", text: text };
        setMessages((messages) => [...messages, userMessage]);

        await sendMessageToBot(text);

        setText("");
      }
    },
    [text]
  );

  useEffect(() => {
    const handleEnter = (event) => {
      if (event.key === "Enter") {
        handleSendMessage(event);
      }
    };

    window.addEventListener("keydown", handleEnter);

    return () => {
      window.removeEventListener("keydown", handleEnter);
    };
  }, [handleSendMessage]);

  const sendMessageToBot = async (userText) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BOT_ENDPOINT}/chatbot`,
        { message: userText }
      );
      setLoading(false);

      const botMessage = { role: "Bot", text: response.data.response };
      setMessages((messages) => [...messages, botMessage]);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="chat-container">
        {!isChatOpen ? (
          <>
            <p className="ai-bot-text">Bot 👋🏻</p>
            <div className="chat-icon" onClick={() => setIsChatOpen(true)}>
              <FontAwesomeIcon
                icon={faCommentDots}
                style={{ color: "#00b57d" }}
                size="2xl"
              />
            </div>
          </>
        ) : (
          <div className="chat-box">
            <div className="chat-message-div-parent">
              <div className="chat-message-div">
                <p style={{ paddingLeft: "10px", fontWeight: "bold" }}>
                  Chat messages
                </p>
              </div>
              <div className="close-icon" onClick={() => setIsChatOpen(false)}>
                <FontAwesomeIcon icon={faXmark} size="lg" />
              </div>
            </div>

            <div className="chat-messages">
              {messages.map((message, index) => (
                <>
                  <div
                    key={index}
                    className={`chat-message ${message.role}-div`}
                  >
                    <span style={{ fontWeight: "bold" }}>{message.role}:</span>{" "}
                    <span style={{ whiteSpace: "pre-wrap" }}>
                      {message.text}
                    </span>
                  </div>
                </>
              ))}
            </div>
            <form className="chat-input-area" onSubmit={handleSendMessage}>
              <input
                type="text"
                className="chat-input"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Type a message..."
              />
            </form>
          </div>
        )}
      </div>
    </>
  );
}

export default Chat;
